export default "__VITE_ASSET__6L_RZatE__"